const translations = { selectQuestions: 'Question selection', question: 'Question', questions: 'Questions' }

export default translations
